import React, { useRef, useCallback } from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';

import 'core-js/stable';

import { useDeductible } from 'products/nomad_insurance/hooks/useDeductible';
import Hero from './components/Hero';
import HomeCountry from './components/HomeCountry';
import SafetyNet from './components/SafetyNet';
import Products from './components/Products';

const HomeContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
`;

const Home = () => {
  const homeCountryRef = useRef();
  const { contractTotalPrice } = useDeductible();

  const scrollToHomeCountry = useCallback(() => {
    const topPadding = 60; // navbar
    window.scrollTo({
      top: homeCountryRef.current?.offsetTop - topPadding,
      behavior: 'smooth'
    });
  }, [homeCountryRef]);

  return (
    <>
      <Helmet>
        <title>SafetyWing - Insurance for Nomads, by Nomads</title>
        <meta
          name="description"
          content={`Insurance for Nomads, by Nomads. Buy abroad, stay abroad. Simple and flexible, works like a subscription. Age 10-39: ${contractTotalPrice} / 4 weeks (other ages available).`}
        />
      </Helmet>
      <HomeContainer>
        <Hero scrollToHomeCountry={scrollToHomeCountry} />
        <HomeCountry ref={homeCountryRef} />
        <SafetyNet />
        <Products />
      </HomeContainer>
    </>
  );
};

export default Home;
